import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  initials: 'CR',
  quote: 'El módulo de evaluación psicopedagógica me dio muchísima claridad. Hoy puedo organizar mejor mis intervenciones.',
  name: 'Cecilia R.',
  location: 'Mendoza'
}, {
  initials: 'SC',
  quote: 'Lo terminé rapidísimo porque todo está muy claro y visual. Se nota que está pensado para la práctica real.',
  name: 'Sofía C.',
  location: 'La Plata'
}, {
  initials: 'PA',
  quote: 'Los recursos editables me salvaron. Antes tardaba muchísimo organizando entrevistas e informes.',
  name: 'Paula A.',
  location: 'Neuquén'
}, {
  initials: 'JM',
  quote: 'El módulo de familias y límites fue clave para mí. Me ayudó muchísimo a ordenar mi rol profesional.',
  name: 'Julia M.',
  location: 'Rosario'
}];
export function TestimonialsRow2() {
  return <section className="py-16 bg-white" data-id="element-248">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-249">
        <div className="text-center mb-10" data-id="element-250">
          <h3 className="font-bold text-navy-900 uppercase tracking-widest text-sm mb-2" data-id="element-251">
            ❤️ Más profesionales que ya lo tienen
          </h3>
          <div className="flex items-center justify-center gap-2 text-slate-600 font-medium" data-id="element-252">
            <span className="text-yellow-400 flex" data-id="element-253">
              <Star className="w-4 h-4 fill-current" data-id="element-254" />
            </span>
            4.8/5 · basado en +2.000 opiniones
          </div>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-255">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-slate-50 rounded-2xl p-6 border border-slate-100 flex flex-col h-full" data-id="element-256">
              <p className="text-slate-700 italic mb-6 flex-grow text-sm" data-id="element-257">
                "{t.quote}"
              </p>
              <div className="flex items-center gap-3" data-id="element-258">
                <div className="w-8 h-8 rounded-full bg-teal-100 text-teal-700 font-bold flex items-center justify-center text-xs" data-id="element-259">
                  {t.initials}
                </div>
                <div data-id="element-260">
                  <div className="font-bold text-navy-900 text-xs" data-id="element-261">
                    {t.name}
                  </div>
                  <div className="text-[10px] text-slate-500 uppercase tracking-wider" data-id="element-262">
                    {t.location}
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}